import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadApplePayScript as loadScript } from '../utils/loadApplePayScript';

export const loadApplePayScript = createAsyncThunk<void, boolean | undefined>('LOAD_APPLE_PAY_SCRIPT', loadScript);
